import { render, staticRenderFns } from "./activitySelect.vue?vue&type=template&id=70b747e9&scoped=true"
import script from "./activitySelect.vue?vue&type=script&lang=js"
export * from "./activitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b747e9",
  null
  
)

export default component.exports